import { MatchTeam } from "@/models/match.model";

export enum RoundTypeCode {
  GroupMatches = "csoport merkozesek",
  LeagueMatches = "bajnoki merkozesek",
  PlayOff = "rajatszas",
  Knockout = "egyenes kieses"
}

export interface RoundType {
  code: RoundTypeCode;
  name: string;
}

export interface RoundBase {
  id: number;
  order: string;
  name: string;
}

export interface Round {
  id: number;
  leagueId: number;
  order: number;
  name: string;
  is_actual: boolean;
  round_type: RoundType;
}

export interface RoundWithMatches extends Round {
  matches: RoundMatch[];
}

export interface RoundMatch {
  id: number;
  round_id: number;
  start_time: string;
  length: string;
  length_of_halftime: string;
  hometeam: MatchTeam;
  awayteam: MatchTeam;
  status: {
    code: string;
    id: number;
    name: string;
  };
  sportfield_id: number;
  sportfield_name: string;
}
